import { useEffect } from 'react';
import { t } from '@lingui/macro';

import { Page, PageHeader, PageActions, PanelContainer } from '../../page-framework';
import { PathDetailPanel, PathVisualizationPanel } from '../../panels';
import { useFilterState } from '../../../stores/FilterStateStore';
import { getEncodedStateFromUrl } from '../../../utilities/FilterStateUrlUtilities';

export const pageId = 'path-detail';
export const pageTitle = t`Path Details`;

export default function PathDetailPage() {
    const [, /* Not used */ filterStateActions] = useFilterState();

    useEffect(() => {
        filterStateActions.initialize(getEncodedStateFromUrl());
    }, [filterStateActions]);

    return (
        <Page id={pageId}>
            <PageHeader
                pageId={pageId}
                title={pageTitle}
                actions={
                    <PageActions
                        pageId={pageId}
                        pageTitle={pageTitle}
                        showTimeRangeControls={false}
                        reportActionOptions={{ canSchedule: false }}
                    />
                }
            />
            <PanelContainer>
                <PathVisualizationPanel hideTitle />
                <PathDetailPanel flexHeight expandable />
            </PanelContainer>
        </Page>
    );
}
